import { TablePage, Dialog } from 'web-mojo';
import { LocationList } from '@portal/models/Location.js';
import '@portal/routes/LocationView.js';
import LocationFormView from '@portal/routes/LocationFormView.js';

export default class LocationsListPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Locations',
            icon: 'bi-geo-alt-fill',
            pageName: 'locations_list',
            route: 'group/locations',
            Collection: LocationList,
            permissions: ['routes', 'view_routes', 'manage_routes', 'manage_cam_devices', 'manage_group'],
            requiresGroup: true,

            viewDialogOptions: {
                header: false,
                size: 'xl',
                footer: false,
            },

            addButtonLabel: 'Add Location',

            tableViewOptions: {
                hideActivePillNames: ['group'],
                onAdd: () => {
                    const form = new LocationFormView();
                    Dialog.showDialog({
                        title: 'Add Location',
                        body: form,
                        size: 'lg',
                        buttons: [
                            { text: 'Cancel', class: 'btn-secondary', dismiss: true },
                            { text: 'Save Location', class: 'btn-primary',
                              handler: async () => {
                                  const ok = await form.onActionSave();
                                  if (ok) this.collection.fetch();
                                  return ok;
                              }
                            },
                        ],
                    });
                },
            },

            defaultQuery: {
                sort: 'name',
                is_active: 'true',
                group: () => app.activeGroup?.id,
            },

            columns: [
                {
                    label: 'Name',
                    key: 'name',
                    formatter: "default('—')",
                },
                {
                    label: 'Address',
                    key: 'address',
                    formatter: "default('—')",
                    visibility: 'md',
                },
                {
                    label: 'Machines',
                    key: 'machine_count',
                    formatter: "default('0')",
                    visibility: 'md',
                },
                {
                    label: 'Status',
                    key: 'is_active',
                    formatter: "yesnoicon('bi bi-circle-fill text-success', 'bi bi-circle text-secondary')",
                    filter: {
                        type: 'select',
                        options: [
                            { label: 'Active', value: 'true' },
                            { label: 'Archived', value: 'false' },
                        ]
                    }
                },
            ],

            selectable: true,

            batchActions: [
                { label: 'Archive', icon: 'bi bi-archive', action: 'archive' },
                { label: 'Activate', icon: 'bi bi-check-circle', action: 'activate' },
                { label: 'Export', icon: 'bi bi-download', action: 'export' },
            ],

            contextMenu: [
                { icon: 'bi-pencil', action: 'edit', label: 'Edit' },
                { icon: 'bi-archive', action: 'archive', label: 'Archive' },
            ],
            searchable: true,
            sortable: true,
            filterable: true,
            paginated: true,

            showExport: false,

            tableOptions: {
                striped: true,
                bordered: false,
                hover: true,
                responsive: false,
            },

            ...options,
        });
    }

    async onActionBatchArchive() {
        const selected = this.tableView.getSelectedItems();
        if (!selected?.length) return;
        const confirmed = await Dialog.confirm({
            title: `Archive ${selected.length} location${selected.length > 1 ? 's' : ''}`,
            message: 'Archive selected locations? They can be reactivated later.',
            confirmText: 'Archive',
            confirmClass: 'btn-warning',
        });
        if (!confirmed) return;
        await Promise.all(selected.map(item => item.model.save({ is_active: false })));
        app.toast.success(`Archived ${selected.length} location${selected.length > 1 ? 's' : ''}`);
        this.tableView.collection.fetch();
    }

    async onActionBatchActivate() {
        const selected = this.tableView.getSelectedItems();
        if (!selected?.length) return;
        await Promise.all(selected.map(item => item.model.save({ is_active: true })));
        app.toast.success(`Activated ${selected.length} location${selected.length > 1 ? 's' : ''}`);
        this.tableView.collection.fetch();
    }

    async onActionBatchExport() {
        this.tableView.collection.export();
    }
}
